import { requestService } from '../';

export const resetUserPasswordApi = async (userEmail: string) => {
	const { data } = await requestService.post(`/entities/user/resetPasswordViaMail`, { body: { email: userEmail } });
	return data;
};
